"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_paper_1 = require("react-native-paper");
const react_native_1 = require("react-native");
const react_native_gesture_handler_1 = require("react-native-gesture-handler");
const styles_1 = __importDefault(require("../../styles/styles"));
const tabsStyles_1 = __importDefault(require("./tabsStyles"));
const pressable_1 = __importDefault(require("../pressable/pressable"));
const eventConstants_1 = require("../../constants/eventConstants");
const Tabs = ({ selectedTab, setSelectedTab, tabs }) => {
    const getTabTextColor = (tabName) => tabName === selectedTab ? styles_1.default.textColorBlue : styles_1.default.textColorGray;
    const getTabTitleStyle = (tabName) => {
        if (tabName === selectedTab) {
            return [tabsStyles_1.default.tab, styles_1.default.alignCenterStart, tabsStyles_1.default.tabSelected, styles_1.default.button];
        }
        return [tabsStyles_1.default.tab, styles_1.default.alignCenterStart, tabsStyles_1.default.tabNotSelected, styles_1.default.button];
    };
    return (react_1.default.createElement(react_native_gesture_handler_1.ScrollView, { horizontal: true, showsHorizontalScrollIndicator: false }, tabs.map((el) => (react_1.default.createElement(react_native_1.View, { key: el.key, style: [styles_1.default.flexOne, styles_1.default.alignCenterCenter] },
        react_1.default.createElement(pressable_1.default, { style: getTabTitleStyle(el.key), onPress: () => setSelectedTab(el.key), eventName: `tap_${el.key.toLowerCase()}_${eventConstants_1.TAB_PRESS}` },
            react_1.default.createElement(react_native_paper_1.Title, { style: [getTabTextColor(el.key), styles_1.default.fontSizeText] }, el.name)))))));
};
exports.default = Tabs;
